<template>
    <product-gallery
        class="accordion-gallery"
        :unordered-slides="sectionGallery.productGallery"
        :products="sectionGallery.products"
        :swipe-instructions="sectionGallery.gallerySwipeInstructions"
        :default-product="sectionGallery.defaultProduct"
    >
        <template #product-description="{products, currentProductSlug}">
            <gallery-product-descriptions
                v-if="!getCurrentProductDescriptionProperty('sections', currentProductSlug)"
                :products="products"
                :current-product-slug="currentProductSlug"
            />
            <photo-gallery-product-descriptions
                v-if="getCurrentProductDescriptionProperty('sections', currentProductSlug)"
                :products="products"
                :current-product-slug="currentProductSlug"
            />
        </template>
    </product-gallery>
</template>
<script>
import ProductGallery from '@web/components/ProductGalleries/ProductGallery';
import GalleryProductDescriptions from '@web/components/ProductGalleries/GalleryProductDescriptions';
import PhotoGalleryProductDescriptions from '@web/pages/sections/PostProductionPage/PhotoGalleryProductDescriptions';
import { get } from 'lodash';

export default {
  components: {
    PhotoGalleryProductDescriptions,
    ProductGallery,
    GalleryProductDescriptions,
  },
  props: {
    sectionGallery: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getCurrentProductDescriptionProperty(property, currentProductSlug) {
      return get(this.sectionGallery.products, [currentProductSlug, 'productDescription', property]);
    },
  },
};

</script>
<style scoped>
</style>
